import { ArrowRight } from '@untitledui/icons';

import {
  AttioBrandMark,
  ProviderLogoTile,
} from '@/components/integrations/ProviderBrandMarks';
import { Input } from '@/lib/base/forms/input/input';
import { AhoyLogoMinimal } from '@/lib/foundations/logo/ahoy-logo-minimal';

import { ATTIO_API_KEYS_URL } from './constants';

interface AttioConnectStepProps {
  apiKey: string;
  onApiKeyChange: (value: string) => void;
  errorMessage: string | null;
}

export function AttioConnectStep({
  apiKey,
  onApiKeyChange,
  errorMessage,
}: AttioConnectStepProps) {
  return (
    <div className='flex flex-col gap-4'>
      {/* Brand lockup: where the data is coming from → where it's going. */}
      <div className='flex items-center gap-3'>
        <ProviderLogoTile>
          <AttioBrandMark className='size-5 text-fg-primary' />
        </ProviderLogoTile>
        <ArrowRight aria-hidden={true} className='size-4 text-fg-quaternary' />
        <ProviderLogoTile>
          <AhoyLogoMinimal className='size-5' />
        </ProviderLogoTile>
      </div>

      <p className='text-sm text-secondary'>
        Paste your Attio API key to connect. You can create one from your Attio
        settings.
      </p>

      <a
        href={ATTIO_API_KEYS_URL}
        target='_blank'
        rel='noopener noreferrer'
        aria-label='Get your Attio API key (opens in new tab)'
        className='text-utility-brand-600 hover:underline font-medium'
      >
        Get your Attio API key
      </a>

      <Input
        label='Attio API key'
        type='password'
        value={apiKey}
        onChange={onApiKeyChange}
        isInvalid={!!errorMessage}
        hint={errorMessage ?? undefined}
      />

      {/* Factual, verifiable claim — the key is stored AEAD-encrypted per
          dispatched job (apps/secrets) and deleted by a post_save signal the
          moment the job reaches a terminal state (attio_import/apps/signals.py).
          Don't strengthen this copy beyond what the backend actually does. */}
      <p className='text-xs text-tertiary'>
        Your key is only used to run this import. It's stored encrypted while
        the import runs, then deleted automatically.
      </p>
    </div>
  );
}
